import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebaseConfig';
import { doc, getDoc } from "firebase/firestore";
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';

const isAugust = () => {
  const today = new Date();
  return today.getMonth() === 7; // 7 représente août
};

const Navbar = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Nouvel état pour suivre l'authentification
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/'); // Redirige vers la page de connexion après la déconnexion
    } catch (error) {
      console.error('Erreur lors de la déconnexion :', error);
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    const checkIfAdmin = async (uid) => {
      const userRef = doc(db, "users", uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists() && userSnap.data().isAdmin) {
        console.log("L'utilisateur est un administrateur");
        return true;
      } else {
        console.log("L'utilisateur n'est pas un administrateur");
        return false;
      }
    };

    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setIsAuthenticated(true); // Met à jour l'état de l'authentification
        const admin = await checkIfAdmin(user.uid);
        setIsAdmin(admin);
      } else {
        setIsAuthenticated(false); // Si pas d'utilisateur, l'authentification est false
        setIsAdmin(false);
      }
    });
    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  const drawer = (
    <div>
      <List>
        {isAuthenticated && ( // Masquer le bouton Accueil si non authentifié
          <ListItemButton component={Link} to="/">
            <ListItemText primary="Accueil" />
          </ListItemButton>
        )}
        {isAdmin && (
          <ListItemButton component={Link} to="/admin">
            <ListItemText primary="Administration" />
          </ListItemButton>
        )}
        {isAuthenticated && (
          <>
            <ListItemButton component={Link} to="/profile">
              <ListItemText primary="Profil" />
            </ListItemButton>
            <ListItemButton button onClick={handleLogout}>
              <ListItemText primary="Se déconnecter" />
            </ListItemButton>
          </>
        )}

      </List>
    </div>
  );

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          {/* Ajouter l'image ici */}
          <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/images/logo.png" alt="Logo" style={{ marginRight: '5px', height: '60px' }} />
          </Link>
          <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
            <Link to="/" style={{ color: 'inherit', textDecoration: 'none', fontWeight: 'bold' }}>
              GestionCantine
            </Link>
          </Typography>
          {isMobile ? (
            <>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="right"
                open={mobileOpen}
                onClose={handleDrawerToggle}
              >
                {drawer}
              </Drawer>
            </>
          ) : (
            <>
              {isAuthenticated && ( // Masquer le bouton Accueil si non authentifié
                <Button color="inherit" component={Link} to="/" sx={{ textTransform: 'none' }}>
                  Accueil
                </Button>
              )}
              {isAdmin && (
                <Button color="inherit" component={Link} to="/admin" sx={{ textTransform: 'none' }}>
                  Administration
                </Button>
              )}

              {isAuthenticated && (
                <>
                  <Button title='Voir son profil' color="inherit" component={Link} to="/profile" sx={{ textTransform: 'none' }}>
                    <PersonIcon />
                  </Button>
                  <Button title='Se déconnecter' color="inherit" onClick={handleLogout} sx={{ textTransform: 'none' }}>
                    <LogoutIcon />
                  </Button>
                </>
              )}

            </>
          )}
        </Toolbar>
      </AppBar>
      {/* Afficher le message d'alerte sous la Navbar tout le temps */}
      <Box sx={{ width: '100%' }}>
        <Alert severity="info" sx={{ alignItems: 'center'}}>
          La date limite d'inscription: le 20 de chaque mois (le 26 en août).
        </Alert>
      </Box>
      {isAugust() && (
        <Box sx={{ width: '100%' }}>
        <Alert severity="warning" sx={{ alignItems: 'center'}}>
          C'est le mois d'août, pensez à mettre à jour les classes de vos enfants si ce n'est pas encore fait. <Link to="/profile" >
                  mettre à jour
                </Link>
        </Alert>
      </Box>
      )}
    </>
  );
};

export default Navbar;
